import { Button, Image, Dropdown, Menu, Tooltip } from "antd";
import { useAuth } from "hooks/queries/useAuth";
import { useInstallationExport } from "hooks/queries/useInstallation";
import { useHistory } from "react-router";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { AiOutlineCaretUp, AiOutlineFileZip } from "react-icons/ai";
import { QueryCache } from "react-query";
import { useTranslation } from "react-i18next";
import { isAdmin, isWorker } from "utils/global";

const TopMenu = ({ onlyIcons, toggleOnlyIcons }: any) => {
  const { user, logout } = useAuth();
  const queryCache = new QueryCache();
  const history = useHistory();
  const { t } = useTranslation();
  const { mutate: exportInstallations, isLoading: isExporting } =
    useInstallationExport();

  const handleLogout = () => {
    const isImpersonating = sessionStorage.getItem("impersonateWorkerToken");

    if (isImpersonating) {
      sessionStorage.removeItem("impersonateWorkerToken");
      queryCache.clear();
      window.location.href = "/login";
    } else {
      logout();
      queryCache.clear();
      history.push("/");
    }
  };

  const menu = (
    <>
      <AiOutlineCaretUp />
      <Menu className="user-dropdown">
        {/* <Menu.Item key="1">My Profile</Menu.Item>
			<Menu.Item key="2">Inbox</Menu.Item> */}
        <Menu.Item key="3" onClick={handleLogout}>
          {t("main:logout")}
        </Menu.Item>
      </Menu>
    </>
  );
  return (
    <div className="top-nav">
      <div className="left-item d-flex align-items-center">
        {/* toggle class logo-toggle in logo while clicking togglebtn */}
        <div className={`logo ${onlyIcons ? "logo-toggle" : ""}`}>
          <Image
            preview={false}
            src="/img/halteverbot24.png"
            style={{ height: 40 }}
          />
        </div>
        <div className="d-flex align-items-center">
          <button className="togglebtn" onClick={toggleOnlyIcons}>
            <HiOutlineMenuAlt3 />
          </button>
        </div>
      </div>
      <div className="user" style={{ alignItems: "center" }}>
        {/* <ul>
					<li>
						<a href="">
							<BiEnvelope />
						</a>
					</li>
					<li>
						<a href="">
							<IoMdNotificationsOutline />
						</a>
					</li>
				</ul> */}
        {isAdmin() && (
          <Tooltip title={t("orders:exportAll")}>
            <Button
              type="primary"
              style={{
                marginRight: 12,
                border: "1px solid gray",
                padding: "0 12px",
              }}
              loading={isExporting}
              onClick={() => exportInstallations()}
            >
              <AiOutlineFileZip />
            </Button>
          </Tooltip>
        )}
        <Dropdown overlay={menu} trigger={["click"]}>
          <div className="site-dropdown-context-menu d-flex">
            <div className="user-avatar">
              <Image
                preview={false}
                src={user?.image ?? "/img/user-1.png"}
                style={{ height: 40 }}
                onError={(e: any) => (
                  (e.target.onerror = null), (e.target.src = "/img/user-1.png")
                )}
              />
            </div>
            <div>
              <span>{t("main:welcome")},</span>
              <h6>
                {user?.firstName} {isWorker() && user?.lastName}
              </h6>
            </div>
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

export default TopMenu;
